export default __webpack_public_path__ + "static/media/Telephonic.124b7da1.svg";